import { render, staticRenderFns } from "./XPorterConfiguration.vue?vue&type=template&id=5022a49e&scoped=true&"
import script from "./XPorterConfiguration.vue?vue&type=script&lang=ts&"
export * from "./XPorterConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./XPorterConfiguration.vue?vue&type=style&index=0&id=5022a49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022a49e",
  null
  
)

export default component.exports